import React, { useState } from 'react';

import styles from './styles.module.css';
import {
  TURBINES_GROUP_PREVIEW_COUNT,
  TurbineLocationGroupData,
  getTurbineGroupDomId
} from '@/containers/GlobalViewContainer/utils';
import { GaugeData } from '@/containers/GlobalViewContainer/types';
import ChevronIcon from '@/assets/icons/chevron.svg?react';
import Gauge from '@/components/Gauge';

type TurbineLocationGroupProps = {
  group: TurbineLocationGroupData;
  defaultExpanded?: boolean;
  onTurbineClick: (gauge: GaugeData) => void;
};

const TurbineLocationGroup = ({
  group,
  defaultExpanded = true,
  onTurbineClick
}: TurbineLocationGroupProps) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const [showAll, setShowAll] = useState(false);
  const groupDomId = getTurbineGroupDomId(group.groupKey);
  const hasMoreTurbines = group.turbines.length > TURBINES_GROUP_PREVIEW_COUNT;
  const visibleTurbines =
    showAll || !hasMoreTurbines
      ? group.turbines
      : group.turbines.slice(0, TURBINES_GROUP_PREVIEW_COUNT);

  const handleShowAllClick = () => {
    setShowAll(true);
  };

  return (
    <section className={styles.groupSection}>
      <div className={styles.groupHeader}>
        <h2 className={styles.groupTitle}>{group.locationName}</h2>
        <div className={styles.groupHeaderLine} />
        <button
          id={`turbineGroupToggle_${groupDomId}`}
          type="button"
          className={styles.groupToggleButton}
          onClick={() => setIsExpanded(prev => !prev)}
          aria-expanded={isExpanded}
          aria-label={`${isExpanded ? 'Collapse' : 'Expand'} ${group.locationName}`}
        >
          <ChevronIcon
            className={`${styles.groupChevron} ${isExpanded ? styles.groupChevronExpanded : ''}`}
          />
        </button>
      </div>

      {isExpanded && (
        <div className={styles.groupContent}>
          <div className={styles.groupCardsGrid}>
            {visibleTurbines.map(gauge => (
              <div key={gauge.id} className={styles.groupCardItem}>
                <Gauge
                  title={gauge.title}
                  subtitle={gauge.subtitle}
                  mainLabel={gauge.mainLabel}
                  currentKw={gauge.currentKw}
                  powerStatus={gauge.powerStatus}
                  maxKw={gauge.maxKw}
                  metrics={gauge.metrics}
                  variant={gauge.variant as GaugeData['variant']}
                  onClick={() => onTurbineClick(gauge)}
                />
              </div>
            ))}
          </div>

          {hasMoreTurbines && !showAll && (
            <button
              id={`turbineGroupShowAll_${groupDomId}`}
              type="button"
              className={styles.showAllButton}
              onClick={handleShowAllClick}
            >
              SHOW ALL
            </button>
          )}
        </div>
      )}
    </section>
  );
};

export default TurbineLocationGroup;
